module.exports = __webpack_public_path__ + "img/Settings.74ab490f.svg";